<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <!-- <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          v-if="auth.can('BE')"
        >
          Auto-Expédition
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button> -->
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-sent-notes"
          v-if="auth.can('ADD_BE_S') && auth.can('BE')"
        >
          Ajouter Bon d'envoie ( SIMPLE )
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          to="/add-global-sent"
          v-if="auth.can('ADD_BE_G') && auth.can('BE')"
        >
          Ajouter Bon denvoie ( GLOBAL )
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card mb-20">
      <div class="card-body">
        <div class="row align-items-end">
          <!-- ZONE ENVOI -->
          <div class="col-md-4 mb-3">
            <label>Zone Envoi</label>
            <v-select
              v-model="sent_zone_filter"
              :options="ZonesList"
              label="name"
              placeholder="Toutes les zones"
            />
              <!-- @search="onSearchZones" -->
          </div>

          <!-- ZONE RÉCEPTION -->
          <div class="col-md-4 mb-3">
            <label>Zone Réception</label>
            <v-select
              v-model="recept_zone_filter"
              :options="ZonesList"
              label="name"
              placeholder="Toutes les zones"
            />
          </div>

          <!-- STATUT -->
          <div class="col-md-4 mb-3">
            <label>Statut</label>
            <select class="form-control" v-model="filters.searchStatut">
              <option value="">Statut (Tous)</option>
              <option :value="0">Attente d'expédition</option>
              <option :value="1">Expédié</option>
              <option :value="2">Reçu</option>
              <option :value="3">Auto Ajout</option>
              <option :value="4">Hors zone</option>
            </select>
          </div>

          <!-- TYPE -->
          <div class="col-md-4 mb-3">
            <label>Type</label>
            <select class="form-control" v-model="filters.searchType">
              <option value="">Type (Tous)</option>
              <option value="GLOBAL">Global</option>
              <option value="SIMPLE">Simple</option>
            </select>
          </div>

          <!-- DATE RANGE -->
          <div class="col-md-4 mb-3">
            <label>Période</label>
            <div class="border p-2 cursor-pointer" @click="showCalendar()">
              {{ selectedDate?.[0]?.format("DD MMM YYYY") || "—" }}
              -
              {{ selectedDate?.[1]?.format("DD MMM YYYY") || "—" }}
              <i class="flaticon-calendar float-end"></i>
            </div>

            <div
              v-show="showCalendarBox"
              class="position-relative mt-2 p-2 bg-white shadow rounded"
              style="z-index: 999"
            >
              <MyDateRangePicker
                v-model="selectedDate"
                @onSelect="showCalendar"
                :enableSecondCalendar="true"
              />
            </div>
          </div>

          <!-- ACTIONS -->
          <div class="col-md-4 mb-3">
            <button class="btn btn-primary me-2" @click="applyFilters">
              Filtrer
            </button>

            <button class="btn btn-outline-danger" @click="resetFilters">
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="applyFilters()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows"
        :loading="isLoader"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Bons Sélectionés',
          disableSelectInfo: true,
        }"
        @select-all="selectNotes"
        @selected-rows-change="onSelectAllNotes"
      >
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <span v-if="props.column.field === 'note_ref'" class="text-nowrap">
            <b>{{ props.row.note_ref }}</b>
          </span>
          <span
            v-else-if="props.column.field === 'created_at'"
            class="text-nowrap"
          >
            <template v-if="props.row.created_at != null">
              {{ getDate(props.row.created_at) }}
            </template>
            <span v-if="props.row.userc"><br/>{{ props.row.userc.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'sent_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.sent_time != null">
              {{ getDate(props.row.sent_time) }}
            </template>
            <span v-if="props.row.suser"><br/>{{ props.row.suser.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'delivery_time'"
            class="text-nowrap"
          >
            <template v-if="props.row.delivery_time != null">
              {{ getDate(props.row.delivery_time) }}
            </template>
            <span v-if="props.row.userd"><br/>{{ props.row.userd.name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'sending_zone_name'"
            class="text-nowrap"
          >
            <h6>{{ props.row.sending_zone_name }}</h6>
            <span>{{ props.row.sending_agency_name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'reception_zone_name'"
            class="text-nowrap"
          >
            <h6>{{ props.row.reception_zone_name }}</h6>
            <span>{{ props.row.reception_agency_name }}</span>
          </span>
          <span
            v-else-if="props.column.field === 'transport'"
            class="text-nowrap"
          >
            <h6>
              {{ props.row.transport }}
              <templat v-if="props.row.transport && props.row.transport_code"
                >({{ props.row.transport_code }})</templat
              >
            </h6>
            <small v-if="props.row.transport && props.row.transport_sacs"
              >{{ props.row.transport_sacs }} Sacs</small
            >
          </span>
          <span
            v-else-if="props.column.field === 'delivered'"
            class="text-nowrap"
          >
            {{ props.row.scanned }}
          </span>
          <template v-else-if="props.column.field === 'sent'">
            <span
              v-if="props.row.sent == 0 && props.row.delivered == 0"
              class="badge rounded-pill fs-13 text-bg-danger"
            >
              Attente d'expédition
            </span>

            <span
              v-else-if="props.row.sent == 0 && props.row.delivered == 4"
              class="badge rounded-pill fs-13 text-bg-primary"
            >
              Hors Zone
            </span>
            <span
              v-if="props.row.sent == 0 && props.row.delivered == 3"
              class="badge rounded-pill fs-13 text-bg-secondary"
            >
              Auto Ajout
            </span>
            <span
              v-else-if="props.row.sent == 1 && props.row.delivered == 0"
              class="badge rounded-pill fs-13 text-bg-info"
            >
              Expédié
            </span>
            <button
              v-if="props.row.sent == 0 && props.row.api_failed > 0"
              type="button"
              class="badge rounded-pill fs-13 text-bg-warning border-0 d-block mt-5"
              title="Voir les colis en erreur"
              @click="showApiResults(props.row)"
            >
              API : {{ props.row.api_failed }} colis en erreur
            </button>
            <span
              v-if="
                props.row.delivered == 1 &&
                (props.row.sent == 1 ||
                  (props.row.sent == 0 &&
                    props.row.reception_agency == props.row.sending_agency))
              "
              class="badge rounded-pill fs-13 text-bg-success"
            >
              Reçu
            </span>
          </template>

          <template v-else-if="props.column.field === 'recu'">
            <!-- && props.row.delivered==0 -->
            <template v-if="props.row.sent == 1">
              <input
                type="checkbox"
                v-if="auth.can('BE') && auth.can('RECEIVE_BE')"
                v-model="props.row.recieved"
                class="custom-control-success"
                name="check-button"
                switch
                @change="recevedNote(props.row)"
                value="1"
                unchecked-value="0"
                :indeterminate="false"
                :disabled="
                  props.row.delivered == 1 &&
                  (props.row.sent == 1 ||
                    (props.row.sent == 0 &&
                      props.row.reception_agency == props.row.sending_agency))
                "
              />
            </template>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    (props.row.delivered == 3 || props.row.delivered == 4) &&
                    props.row.reception_agency != props.row.sending_agency
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="toExpedition(props.row)"
                  >
                    <i
                      class="flaticon-telegram lh-1 me-8 position-relative top-1"
                    ></i>
                    Vers Expédition
                  </button>
                </li>

                <li v-if="auth.can('BE') && props.row.sent == 1">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showModalRecieved(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li v-if="auth.can('BE') && props.row.sent == 0">
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showModalRecieved(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.sent == 0 &&
                    props.row.delivered == 0 &&
                    props.row.reception_agency != props.row.sending_agency
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="transportBon(props.row)"
                  >
                    <i
                      class="flaticon-express-delivery lh-1 me-8 position-relative top-1"
                    ></i>
                    Expédier
                  </button>
                </li>
                <li
                  v-if="
                    auth.can('BE') &&
                    (props.row.api_success > 0 || props.row.api_failed > 0)
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showApiResults(props.row)"
                  >
                    <i
                      class="flaticon-list lh-1 me-8 position-relative top-1"
                    ></i>
                    Envoi prestataire
                  </button>
                </li>
                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num != 0 &&
                    props.row.delivered == 0 &&
                    (props.row.sent == 1 ||
                      (props.row.sent == 0 &&
                        props.row.reception_agency == props.row.sending_agency))
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="distributionBon(props.row)"
                  >
                    <i
                      class="flaticon-check lh-1 me-8 position-relative top-1"
                    ></i>
                    Reçu
                  </button>
                </li>

                <li
                  v-if="
                    auth.can('BE') &&
                    props.row.parcels_num == 0 &&
                    props.row.delivered == 0 &&
                    props.row.sent == 0
                  "
                >
                  <button
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeNote(props.row)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>

                <li>
                  <router-link
                    v-if="
                      auth.can('BE') &&
                      props.row.delivered == 0 &&
                      props.row.sent == 0 &&
                      props.row.type_note == 'SIMPLE'
                    "
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'EditSentNotePage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-edit lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>

                <!-- <li>
                  <router-link
                    v-if="
                      auth.can('BE') && props.row.delivered == 0 &&
              props.row.sent == 0 &&
              props.row.type_note == 'GLOBAL'
                    "
                    class="dropdown-item d-flex align-items-center"
                    :to="{
                      name: 'AddReceptionHCPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-edit2 lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li> -->

                <li>
                  <a
                    v-if="auth.can('BE') && props.row.parcels_num != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>
                <li>
                  <a
                    v-if="auth.can('BE') && props.row.parcels_num != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="ticketsPDF(props.row)"
                  >
                    <i
                      class="flaticon-menu-1 lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets
                  </a>
                </li>
                <li>
                  <a
                    v-if="auth.can('BE') && props.row.parcels_num != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="exportExcel(props.row)"
                  >
                    <i
                      class="flaticon-document lh-1 me-8 position-relative top-1"
                    ></i>
                    Excel
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <div class="modal fade" id="modal_ShowBe" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <ShowEditBn
            :rowBE="noteRow"
            :getRecords="getRecords"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_ShowReceivedColi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détails du Bon</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" v-if="isOpen">
          <EditSentNote2
            v-if="noteRow"
            :rowBE="noteRow"
            :getRecords="getRecords"
            :type="true"
            :isOpen="isOpen"
          />
          <!-- <EditSentNote2 v-if="noteRow && Object.keys(noteRow).length != 0" :key="noteRow.id"  :rowBE="noteRow" :getRecords="getRecords" :type="true"  :isOpen="isOpen" /> -->
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal_transport" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            Expedier le bon : {{ TransRow?.note_ref }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="expedierBon(TransRow.id)">
            <div class="row">
              <div class="col-12 mb-20">
                <div
                  class="form-group"
                  label="Choisir Transport"
                  label-for="trans"
                >
                  <label for="driver">Transport</label>
                  <v-select
                    class="custom-select-height"
                    :options="zoneTransports"
                    v-model="transport"
                    label="name"
                  >
                    <template #no-options>
                      Aucun transport n'est configuré pour la zone de ce bon.
                    </template>
                    <!-- @search="onSearchTrans" <template slot="no-options">
                  Taper un mot pour chercher un transport
                </template> -->
                  </v-select>
                </div>
              </div>

              <div class="col-md-6 mb-20">
                <div
                  class="form-group"
                  label-for="name"
                  label="Le nombre de sacs"
                >
                  <label for="sacs">Le nombre de sacs</label>
                  <input
                    id="sacs"
                    class="form-control"
                    v-model="sacs_transport"
                    name="sacs"
                    type="number"
                    min="0"
                    step="1"
                  />
                </div>
              </div>

              <!-- Hidden when a per-bag tariff exists: fees = tariff × bags are computed and sent silently -->
              <div v-if="!feesAuto" class="col-md-6 mb-20">
                <div class="form-group">
                  <label for="fees_transport">
                    Frais de transport ({{ $devis }}) <span class="text-danger">*</span>
                  </label>
                  <input
                    id="fees_transport"
                    class="form-control"
                    v-model="fees_transport"
                    name="fees_transport"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                  />
                  <small v-if="transport" class="text-muted d-block mt-5">
                    Aucun tarif par sac pour cette zone : saisissez les frais.
                  </small>
                </div>
              </div>
              <div class="col-md-12 mb-20" v-if="transport?.type == 2">
                <div class="form-group" label-for="name" label="Code d\'envoie">
                  <label for="code_transport">Code d'envoie</label>
                  <input
                    class="form-control"
                    v-model="code_transport"
                    name="name"
                  />
                </div>
              </div>

              <div class="col-12" >
                <div class="form-group">
                  <label for="provider">Prestataire <small class="text-muted">(facultatif)</small></label>
                  <v-select
                    input-id="provider"
                    class="custom-select-height"
                    :options="providerList"
                    v-model="provider"
                    label="name"
                    :disabled="!!TransRow?.api_success && !!TransRow?.delivery_provider_id"
                  >
                    <template #no-options>
                      Aucun livreur prestataire actif.
                    </template>
                    <template #option="opt">
                      {{ opt.name }}
                      <small v-if="!opt.api_configured" class="text-muted">— sans API</small>
                    </template>
                  </v-select>
                  <small v-if="provider && !provider.api_configured" class="text-muted d-block mt-5">
                    Prestataire sans API : il est seulement enregistré sur le bon, qui est expédié directement.
                  </small>
                  <small v-else-if="provider" class="text-muted d-block mt-5">
                    Les colis du bon sont envoyés automatiquement via l'API du prestataire.
                    Si tous les colis sont acceptés, le bon est expédié et un bon de distribution est créé à son nom puis passé à « Reçu ».
                  </small>
                  <small v-else class="text-muted d-block mt-5">
                    Sans prestataire, le bon est expédié directement, sans envoi API.
                  </small>
                  <small
                    v-if="TransRow?.api_success && TransRow?.delivery_provider_id"
                    class="text-warning d-block"
                  >
                    {{ TransRow.api_success }} colis déjà créé(s) chez
                    {{ TransRow.delivery_provider_name }} : le prestataire ne peut plus être changé.
                  </small>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            :disabled="expediting"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="expedierBon(TransRow.id)"
            class="btn btn-primary"
            :disabled="expediting"
          >
            <span
              v-if="expediting"
              class="spinner-border spinner-border-sm me-5"
              role="status"
            ></span>
            {{ expediting && provider?.api_configured ? "Envoi au prestataire…" : "Enregistrer" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_provider_results"
    tabindex="-1"
    aria-labelledby="providerResultsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
      <div class="modal-content p-15 p-md-30">
        <div class="modal-header">
          <h1 id="providerResultsLabel" class="modal-title fs-5">
            Envoi au prestataire — {{ apiNote?.note_ref }}
            <small v-if="apiNote?.delivery_provider_name" class="text-muted">
              ({{ apiNote.delivery_provider_name }})
            </small>
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
            :disabled="retrying"
          ></button>
        </div>

        <div class="modal-body">
          <div v-if="apiLoading" class="text-center py-4">
            <span class="spinner-border" role="status"></span>
          </div>
          <template v-else>
            <div
              class="alert"
              :class="apiNote?.sent == 1 ? 'alert-success' : apiCounts.failed ? 'alert-danger' : 'alert-info'"
              role="status"
            >
              <strong>{{ apiCounts.success }}</strong> colis créé(s),
              <strong>{{ apiCounts.failed }}</strong> en erreur<template v-if="apiCounts.sending">,
              <strong>{{ apiCounts.sending }}</strong> en cours</template>.
              <template v-if="apiNote?.sent == 1">
                Le bon est expédié.
              </template>
              <template v-else-if="apiCounts.failed">
                Le bon reste en attente d'expédition tant que des colis sont en erreur.
                Corrigez-les (ou retirez-les du bon) puis relancez : les colis déjà créés ne sont pas renvoyés.
              </template>
            </div>

            <div class="table-responsive">
              <table class="table align-middle api-results">
                <thead>
                  <tr>
                    <th>Colis</th>
                    <th>Destinataire</th>
                    <th>Statut</th>
                    <th>N° de suivi</th>
                    <th>Erreur</th>
                    <th class="text-center">Essais</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="s in apiShipments" :key="s.id">
                    <tr>
                      <td><b>{{ s.coli_code }}</b></td>
                      <td>
                        {{ s.receiver }}
                        <small class="d-block text-muted">{{ s.city_name }}</small>
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill"
                          :class="{
                            'text-bg-success': s.status === 'success',
                            'text-bg-danger': s.status === 'failed',
                            'text-bg-warning': s.status === 'sending',
                          }"
                        >
                          {{ s.status === "success" ? "Créé" : s.status === "failed" ? "Erreur" : "En cours" }}
                        </span>
                        <small v-if="s.http_code" class="d-block text-muted">HTTP {{ s.http_code }}</small>
                      </td>
                      <td>{{ s.tracking_number || "—" }}</td>
                      <td class="api-error">{{ s.error_message || "—" }}</td>
                      <td class="text-center">{{ s.attempts }}</td>
                      <td class="text-end">
                        <button
                          type="button"
                          class="btn btn-sm btn-light"
                          :aria-expanded="openedShipment === s.id"
                          @click="openedShipment = openedShipment === s.id ? null : s.id"
                        >
                          {{ openedShipment === s.id ? "Masquer" : "Détails" }}
                        </button>
                      </td>
                    </tr>
                    <tr v-if="openedShipment === s.id" class="api-detail">
                      <td colspan="7">
                        <div class="row g-3">
                          <div class="col-md-6">
                            <small class="text-muted">Requête — {{ s.request_url }}</small>
                            <pre>{{ prettyJson(s.request_payload) }}</pre>
                          </div>
                          <div class="col-md-6">
                            <small class="text-muted">Réponse du prestataire</small>
                            <pre>{{ prettyJson(s.response_body) || "Aucune réponse" }}</pre>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr v-if="!apiShipments.length">
                    <td colspan="7" class="text-center text-muted">Aucun envoi pour ce bon.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="retrying">
            Fermer
          </button>
          <button
            v-if="apiNote?.sent == 0 && apiCounts.failed"
            type="button"
            class="btn btn-primary"
            :disabled="retrying"
            @click="retryShipments"
          >
            <span v-if="retrying" class="spinner-border spinner-border-sm me-5" role="status"></span>
            Relancer les {{ apiCounts.failed }} colis en erreur
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_distribution"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            Reçu le bon : {{ TransRow?.note_ref }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div
                class="form-group"
                label="Auto Distribution"
                label-for="distr"
              >
                <label for="driver">Auto distribution</label>
                <select class="form-control" v-model="auto_distr">
                  <option value="0">Non</option>
                  <option value="1">Oui</option>
                </select>
              </div>
            </div>

            <div v-if="auto_distr == 1" class="col-12">
              <label for="driver">Livreur</label>
              <div class="form-group" label="Livreur" label-for="distr">
                <!-- LivsZone -->
                <v-select :options="livsZone" v-model="livreur" label="name">
                </v-select>
                <small v-if="TransRow?.delivery_provider_id" class="text-muted d-block mt-5">
                  Bon lié au prestataire {{ TransRow.delivery_provider_name }} : seul son livreur peut être choisi.
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="reçuBon(TransRow.id)"
            class="btn btn-primary"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { currency } from "@/utils/currency";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { dt } from "@fullcalendar/core/internal-common";
import router from "@/router";

import ShowEditBn from "@/components/Notes/SentNotes/ShowEditBn.vue";
import EditSentNote2 from "@/components/Notes/SentNotes/EditSentNote2.vue";
import MyDateRangePicker from "@/components/MyDateRangePicker.vue";

export default {
  name: "ListeNotes",
  components: {
    ShowEditBn,
    EditSentNote2,
    MyDateRangePicker,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const noteRow = ref(null);
    const zonesList = ref([]);
    const transportList = ref([]);
    const transport = ref(null);
    const code_transport = ref("");
    const sacs_transport = ref("");
    const fees_transport = ref(null);
    // only the transports that serve the zone of the note being shipped
    const zoneTransports = computed(() => {
      const zone = TransRow.value?.reception_zone;
      return transportList.value.filter((t: any) =>
        (t.zones || []).some((z: any) => String(z.zone_id) === String(zone))
      );
    });
    const providerList = ref([]);
    const provider = ref(null);

    // Shipping fees pre-filled with the transport's tariff for the reception zone × bags, still editable
    const transportPrice = computed(() => {
      const zone = TransRow.value?.reception_zone;
      const zp = (transport.value?.zones || []).find((z) => String(z.zone_id) === String(zone));
      const p = zp ? zp.price_per_bag : transport.value?.price_per_bag;
      return p === null || p === undefined || p === "" ? null : Number(p);
    });
    const feesAuto = computed(() => transportPrice.value !== null);
    const fmtDh = (v) =>
      Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` ${currency()}`;
    let keepFees = false; // reopening a note: keep the fees already saved on it
    watch([transport, sacs_transport], () => {
      if (!feesAuto.value || keepFees) return;
      const bags = parseInt(String(sacs_transport.value || 0), 10);
      fees_transport.value = bags > 0 ? Math.round(transportPrice.value * bags * 100) / 100 : null;
    });
    const expediting = ref(false);
    const auto_distr = ref(0);
    const livreur = ref({ id: 0, name: null });
    const distrub = ref(null);
    const livsZone = ref([]);
    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "ENVOIE",
        field: "sending_zone_name",
      },
      {
        label: "RECEPTION",
        field: "reception_zone_name",
      },
      {
        label: "Type",
        field: "type_note",
      },
      {
        label: "Statut",
        field: "sent",
      },
      {
        label: "Date d'expédition",
        field: "sent_time",
      },
      {
        label: "Date de réception",
        field: "delivery_time",
      },
      {
        label: "Colis",
        field: "parcels_num",
        width: "100px",
      },
      {
        label: "Reçu",
        field: "delivered",
      },
      {
        label: "Transport",
        field: "transport",
      },
      // {
      //   label: "Bon Reçu",
      //   field: "recu",
      // },
      {
        label: "Action",
        field: "action",
      },
    ];

    // Declare missing refs for transportBon
    const TransRow = ref<{ id?: number; note_ref?: string; reception_zone?: number | string } | null>(null);
    const transport_auto = ref({});
    const code_transport_auto = ref("");
    const fees_transport_auto = ref("");
    const sacs_transport_auto = ref("");
    const filters = reactive({
      searchTerm: "",
      searchSentZone: "",
      searchReceptZone: "",
      searchStatut: "",
      searchType: "",
      searchSDate: "",
      searchEDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const ZonesList = ref([]);
    const sent_zone_filter = ref(null);
    const recept_zone_filter = ref(null);

    onMounted(async () => {
      getRecords();
      api.get(`/api/auth/ActiveTransportList`).then((res) => {
        transportList.value = res.data;
      });
      api.get(`/api/auth/ActiveDeliveryProviders`).then((res) => {
        providerList.value = res.data || [];
      });

      try {
        const response = await api.get(`/api/auth/ListZone`);
        ZonesList.value = response.data;
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      }
    });
    async function getRecords(page = 1) {
      isLoader.value = true;
      filters.current_page = page;
      try {
        const response = await api.get(
          `/api/auth/ListSendNote?searchTerm=${filters.searchTerm}&searchSentZone=${filters.searchSentZone}&searchReceptZone=${filters.searchReceptZone}&searchStatut=${filters.searchStatut}&searchType=${filters.searchType}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function applyFilters() {
      //   filters.searchCustomer = customer_filter.id
      //   filters.searchStatut = status_filter
      //   filters.searchStore = store_filter.id
      //   filters.searchSDate = ($refs.myInput.dateRange.start == undefined || $refs.myInput.dateRange.start == 'undefined') ? '' : convert($refs.myInput.dateRange.start)
      //   filters.searchEDate = ($refs.myInput.dateRange.end == undefined || $refs.myInput.dateRange.end == 'undefined') ? '' : convert($refs.myInput.dateRange.end)
       filters.searchSentZone = sent_zone_filter.value?.id || "";
        filters.searchReceptZone = recept_zone_filter.value?.id || "";
      // Date range
      filters.searchSDate = selectedDate.value?.[0]
        ? selectedDate.value[0].format("YYYY-MM-DD")
        : "";

      filters.searchEDate = selectedDate.value?.[1]
        ? selectedDate.value[1].format("YYYY-MM-DD")
        : "";
      filters.current_page = 1;
      getRecords();
    }
    function resetFilters() {
      Object.assign(filters, {
        searchSentZone: "",
        searchReceptZone: "",
        searchStatut: "",
        searchType: "",
        searchSDate: "",
        searchEDate: "",
        current_page: 1,
      });
      recept_zone_filter.value = null;
      sent_zone_filter.value = null;
      selectedDate.value = null;
      filters.current_page = 1;
      getRecords();
    }
    function convert(str: string) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function onSearchZones(search: string, loading: (state: boolean) => void) {
      if (search.length && zonesList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/ListZone`).then((res) => {
          zonesList.value = res.data.users.data;
          zonesList.value.unshift({ id: "", name: "Tous" });
          loading(false);
        });
      }
    }

    function onSearchTrans(search: string, loading: (state: boolean) => void) {
      if (search.length && transportList.value.length == 0) {
        loading(true);
        api.get(`/api/auth/ActiveTransportList`).then((res) => {
          transportList.value = res.data.users.data;
          loading(false);
        });
      }
    }

    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(debounceTimer);

      //   // Set a new debounce timer
      //   debounceTimer = setTimeout(() => {
      //     if (!searchTerm || searchTerm === '') {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   } else if (searchTerm && searchTerm.length > 4) {
      //     filters.searchTerm = searchTerm
      //     filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      applyFilters();
    }

    async function removeNote(row) {
      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/RemoveSent/${row.id}`);

          if (res.data.message === "success") {
            showToast("Bon  est bien supprimé", "success");

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `getRecords()`.
          } else if (res.data.message === "error") {
            showToast("Vous pouvez pas le supprimer!", "error");
          }
        } catch (error) {
          console.error("Erreur suppression :", error);
          showToast("Something went wrong! Veuillez réessayer", "error");
        }
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/SentPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function openReception(row) {
      try {
        let data = new FormData();
        data.append("UserID", user?.id);
        data.append("ref_note", row.note_ref);
        data.append("cstmr", row.note_customer);
        const res = await api.post(`/api/auth/OpenBrc/${row.id}`, data);

        if (res.data.message === "success") {
          showToast("Bon de reception est bien modifié", "success");
          getRecords(); // 🔹 if Composition API. Use `getRecords()` if Options API.
        } else {
          showToast("Erreur, merci de réessayer encore!", "error");
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    async function ticketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketSentPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF (4 tickets)",
        });
      }
    }
    async function exportExcel(row) {
      try {
        const response = await api.get(`/api/auth/SentExcel/${row.id}`, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${row.note_ref}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Erreur export Excel:", error);
        showToast("Impossible d'exporter le fichier Excel", "error");
      }
    }
    function showModal(row) {
      noteRow.value = {};
      // noteBmBL=[];
      noteRow.value = row;

      const modalEl = document.getElementById("detailBonModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    function hideModal(id: string) {
      const modalEl = document.getElementById(id);
      if (modalEl) (Modal.getInstance(modalEl) || new Modal(modalEl)).hide();
    }

    // Messages of ExpedBE / retryProviderShipments that are not a per-parcel result
    const apiMessages = {
      provider_required: "Ce prestataire n'est plus actif.",
      provider_not_configured: "L'API de ce prestataire n'est pas configurée.",
      provider_locked: "Des colis sont déjà créés chez un autre prestataire : il ne peut plus être changé.",
      provider_not_driver: "Seuls les livreurs établis comme prestataires peuvent être choisis.",
      busy: "Un envoi est déjà en cours pour ce bon, patientez puis réessayez.",
      no_parcels: "Aucun colis de ce bon n'est prêt à être expédié.",
      already_sent: "Ce bon est déjà expédié.",
      fees_required: "Les frais de transport sont obligatoires (0 ou plus).",
      sacs_required: "Le nombre de sacs est obligatoire pour calculer les frais de ce transport.",
      "error transport": "Transport choisi n'existe pas",
    };

    async function expedierBon(id) {
      if (!transport.value) {
        showToast("Champs transport est obligatoire", "warning");
        return;
      }
      const fees = fees_transport.value;
      if (fees === null || fees === "" || Number(fees) < 0) {
        showToast("Les frais de transport sont obligatoires", "warning");
        return;
      }
      const external = !!provider.value; // with or without API, the backend decides
      let data = new FormData();
      data.append("UserID", user?.id);
      data.append("note_id", id);
      data.append("trans_id", transport.value.id);
      data.append("trans_name", transport.value.name);
      data.append("code_transport", code_transport.value);
      data.append("sacs_transport", sacs_transport.value);
      data.append("fees_transport", String(fees));
      if (external) data.append("provider_id", provider.value.id);

      expediting.value = true;
      try {
        const res = await api.post(`/api/auth/ExpedBE`, data);
        const msg = res.data?.message;

        if (res.data?.api && ["success", "partial", "failed"].includes(msg)) {
          hideModal("modal_transport");
          getRecords();
          const row = TransRow.value;
          showSendReport(res.data, provider.value.name, () => showApiResults(row, res.data.shipments));
        } else if (msg === "success") {
          getRecords();
          hideModal("modal_transport");
          showToast("Bon est bien expédié", "success");
        } else if (apiMessages[msg]) {
          showToast(apiMessages[msg], "error");
        } else {
          showToast(res.data?.error || "Vous ne pouvez pas expédier ce bon", "error");
        }
      } catch (error) {
        console.error("Erreur expédition :", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      } finally {
        expediting.value = false;
      }
    }

    function escapeHtml(value) {
      return String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    }

    /**
     * Result of the provider API send (ExpedBE / retry), shown to the admin:
     * counts, codes of the parcels in error with the provider reason, and the
     * distribution note created and received for the driver when every parcel succeeded.
     * French fragments are kept in their own elements so the DOM dictionary can translate them.
     */
    async function showSendReport(data, providerName, openDetails) {
      const summary = data.summary || { success: 0, failed: 0 };
      const failures = data.failures || [];
      const name = escapeHtml(providerName || "");
      let icon, title, html;

      if (data.message === "success") {
        const dist = data.distribution;
        icon = dist?.error ? "warning" : "success";
        title = "Envoi terminé avec succès";
        html = `<p><b>${summary.success}</b> <span>colis envoyés avec succès à</span> <b>${name}</b>.</p>`
          + `<p><span>Le bon d'envoi est expédié.</span></p>`;
        if (dist?.error) {
          html += `<div style="text-align:left" class="alert alert-warning mb-0">`
            + `<span>Le bon de distribution n'a pas pu être créé automatiquement :</span> ${escapeHtml(dist.error)}</div>`;
        } else if (dist) {
          html += `<div style="text-align:left" class="alert alert-success mb-0">`
            + `<span>Bon de distribution</span> <b>${escapeHtml(dist.note_ref)}</b> <span>créé et passé à l'état « Reçu »</span>`
            + ` (<b>${dist.parcels}</b> <span>colis</span>).</div>`;
        }
        await Swal.fire({ icon, title, html, confirmButtonText: "OK" });
        return;
      }

      icon = summary.success > 0 ? "warning" : "error";
      title = summary.success > 0 ? "Envoi terminé avec des erreurs" : "Échec de l'envoi";
      const items = failures
        .map((f) => `<li><b>${escapeHtml(f.code)}</b> : ${f.error ? escapeHtml(f.error) : "<span>raison non communiquée par l'API</span>"}</li>`)
        .join("");
      html = `<div style="text-align:left">`
        + `<p class="mb-5"><b>${summary.success}</b> <span>colis envoyés avec succès.</span></p>`
        + `<p class="mb-5"><b>${summary.failed}</b> <span>colis n'ont pas pu être envoyés :</span> `
        + `<b>${failures.map((f) => escapeHtml(f.code)).join(", ")}</b></p>`
        + (items ? `<ul style="max-height:220px;overflow:auto;padding-left:18px;font-size:13px">${items}</ul>` : "")
        + `<p class="mb-0 text-muted"><span>Le bon reste en attente d'expédition et aucun bon de distribution n'est créé tant que tous les colis ne sont pas envoyés. Consultez les détails pour relancer les colis en erreur.</span></p>`
        + `</div>`;
      const result = await Swal.fire({
        icon,
        title,
        html,
        width: 640,
        showCancelButton: true,
        confirmButtonText: "Voir les détails",
        cancelButtonText: "Fermer",
      });
      if (result.isConfirmed && openDetails) openDetails();
    }

    // ── Provider API results ──
    const apiNote = ref(null);
    const apiShipments = ref([]);
    const apiLoading = ref(false);
    const retrying = ref(false);
    const openedShipment = ref(null);
    const apiCounts = computed(() => ({
      success: apiShipments.value.filter((s) => s.status === "success").length,
      failed: apiShipments.value.filter((s) => s.status === "failed").length,
      sending: apiShipments.value.filter((s) => s.status === "sending").length,
    }));

    function prettyJson(value) {
      if (!value) return "";
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    }

    async function loadApiResults(noteId) {
      apiLoading.value = true;
      try {
        const res = await api.get(`/api/auth/providerShipments/${noteId}`);
        apiNote.value = res.data.note;
        apiShipments.value = res.data.shipments || [];
      } catch (error) {
        showToast("Impossible de charger les résultats de l'envoi", "error");
      } finally {
        apiLoading.value = false;
      }
    }

    function showApiResults(row, shipments = null) {
      openedShipment.value = null;
      apiNote.value = { id: row.id, note_ref: row.note_ref, sent: 0, delivery_provider_name: row.delivery_provider_name };
      apiShipments.value = shipments || [];
      loadApiResults(row.id);
      const modalEl = document.getElementById("modal_provider_results");
      if (modalEl) (Modal.getInstance(modalEl) || new Modal(modalEl)).show();
    }

    async function retryShipments() {
      if (!apiNote.value) return;
      retrying.value = true;
      try {
        const res = await api.post(`/api/auth/retryProviderShipments/${apiNote.value.id}`);
        const msg = res.data?.message;
        if (res.data?.api && ["success", "partial", "failed"].includes(msg)) {
          apiShipments.value = res.data.shipments || [];
          await loadApiResults(apiNote.value.id);
          getRecords();
          // the results modal stays open behind: it already shows the details
          showSendReport(res.data, apiNote.value?.delivery_provider_name, null);
        } else {
          showToast(apiMessages[msg] || res.data?.error || "La relance a échoué", "error");
        }
      } catch (error) {
        console.error("Erreur relance :", error);
        showToast("Something went wrong! Veuillez réessayer", "error");
      } finally {
        retrying.value = false;
      }
    }

    async function reçuBon(id) {
      console.log(id);
      let data = new FormData();
      data.append("note_id", id);
      data.append("distr", auto_distr.value.toString());
      data.append("livreur", String(livreur.value.id || 0));
      data.append("liv_name", livreur.value.name || "");

      if (auto_distr.value == 1 && livreur.value.id == 0) {
        showToast("Merci de choisir un livreur!", "warning");
        return;
      }

      const result = await Swal.fire({
        text: "Vous voulez modifier ce bon ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, modifier!",
      });

      if (result.isConfirmed) {
        const res = await api.post(`/api/auth/DelivredBE`, data);
        if (res.data.message == "success") {
          showToast("Bon est bien modifié", "success");
          getRecords();
          const modalEl = document.getElementById("modal_distribution");
          if (modalEl) {
            const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
            modal.hide();
          }
        } else if (res.data.message == "provider_driver_only") {
          showToast("Ce bon est lié à un prestataire : choisissez son livreur.", "error");
        } else {
          showToast("Erreur est survenue!", "error");
        }
      }
    }

    async function distributionBon(row) {
      console.log(row);
      livreur.value = { id: 0, name: null };
      distrub.value = row;
      auto_distr.value = 0;
      TransRow.value = row;

      try {
        const res = await api.get(`/api/auth/LivsZone/${row.reception_agency}`);
        livsZone.value = res.data;
        // note linked to a provider: only the provider's driver can receive the distribution
        if (row.delivery_provider_id) {
          const prov = providerList.value.find((p) => p.id == row.delivery_provider_id);
          if (prov) {
            const found = livsZone.value.find((l) => l.id == prov.user_id);
            livsZone.value = [found || { id: prov.user_id, name: prov.name }];
          }
        }
      } catch (error) {
        showToast("Erreur lors du chargement des livreurs", "error");
        console.log(error);
      }
      const modalEl = document.getElementById("modal_distribution");
      if (modalEl) {
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.show();
      }
    }

    async function recevedNote(note) {
      try {
        const result = await Swal.fire({
          text: "Ce bon est reçu ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, Reçu!",
          cancelButtonText: "Annuler",
        });

        if (result.isConfirmed) {
          let data = new FormData();
          data.append("note_id", note.id);
          data.append("note_ref", note.note_ref);
          data.append("recieved", note.recieved);

          const res = await api.post(`/api/auth/recevedNoteSent`, data);

          if (res.data.message === "success") {
            showToast("Bon est bien reçu", "success");
            getRecords();
          } else if (
            res.data.message === "error note" ||
            res.data.message === "no perms"
          ) {
            showToast("Vous pouvez pas modifier ce bon", "error");
          } else {
            showToast("Erreur est survenue!", "error");
          }
        } else {
          note.recieved = !note.recieved;
        }
      } catch (error) {
        showToast("Something went wrong! Veuillez réessayer", "error");
        console.log(error);
      }
    }

    async function toExpedition(row) {
      try {
        const result = await Swal.fire({
          text: "Vous voulez modifier ce bon vers expédition?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, modifier!",
        });

        if (result.isConfirmed) {
          let data = new FormData();
          data.append("note_id", row.id);

          const res = await api.post(`/api/auth/toExpeditionBE`, data);

          if (res.data.message === "success") {
            showToast("Bon est bien modifié", "success");
            getRecords();
          } else {
            showToast(res.data.message || "Erreur est survenue!", "error");
          }
        }
      } catch (error) {
        showToast("Something went wrong! Veuillez réessayer", "error");
        console.log(error);
      }
    }

    const AutoNotes = ref([]);

    const selectNotes = (params) => {
      params.selectedRows.forEach((element) => {
        if (
          element.parcels_num != 0 &&
          element.sent == 0 &&
          element.reception_agency != element.sending_agency
        ) {
          if (!AutoNotes.value.includes(element)) {
            AutoNotes.value.push(element);
          }
        } else {
          element.vgtSelected = false;
        }
      });
    };
    const onSelectAllNotes = (params) => {
      params.selectedRows.forEach((element) => {
        if (
          element.parcels_num != 0 &&
          element.sent == 0 &&
          element.reception_agency != element.sending_agency
        ) {
          if (!AutoNotes.value.includes(element)) {
            AutoNotes.value.push(element);
          }
        } else {
          element.vgtSelected = false;
        }
      });
    };

    function transportBon(row) {
      // Reset transport-related refs
      transport.value = null;
      provider.value = null;
      TransRow.value = null;

      code_transport.value = "";
      fees_transport.value = null;
      sacs_transport.value = "";

      // Declare TransRow and related variables before using them
      TransRow.value = row;
      // a previous API attempt: same transport and provider (created parcels cannot move)
      if (row.delivery_provider_id) {
        transport.value = transportList.value.find((t) => t.id == row.transport_id) || null;
        provider.value = providerList.value.find((p) => p.id == row.delivery_provider_id) || null;
        code_transport.value = row.transport_code || "";
        sacs_transport.value = row.transport_sacs || "";
        fees_transport.value = row.transport_fees ?? null;
        keepFees = true;
        nextTick(() => (keepFees = false));
      }
      transport_auto.value = {};
      code_transport_auto.value = "";
      fees_transport_auto.value = "";
      sacs_transport_auto.value = "";

      const modalEl = document.getElementById("modal_transport");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    const isOpen = ref(false);
    function showModalRecieved(row) {
      if (row.sent == 0) {
        noteRow.value = {};
        noteRow.value = row;
        // You can add logic to show a modal if needed
        const modalEl = document.getElementById("modal_ShowBe");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true;
          modal.show();
        }
      } else {
        noteRow.value = {};
        noteRow.value = row;
        // You can add logic to show a modal if needed
        const modalEl = document.getElementById("modal_ShowReceivedColi");
        if (modalEl) {
          const modal = new Modal(modalEl);
          isOpen.value = true;
          modal.show();
        }
      }
    }

    const todayDt = moment();
    const firstDt = moment().subtract(8, "M");
    const selectedDate = ref(null);

    const showCalendarBox = ref(false);

    function showCalendar() {
      console.log(selectedDate.value);
      showCalendarBox.value = !showCalendarBox.value;
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      applyFilters,
      convert,
      resetFilters,
      handleInput,
      showModal,
      removeNote,
      getPDF,
      openReception,
      noteRow,

      onSearchTrans,
      onSearchZones,
      expedierBon,
      transportPrice,
      feesAuto,
      fmtDh,
      reçuBon,
      distributionBon,
      recevedNote,
      toExpedition,
      selectNotes,
      onSelectAllNotes,
      transportBon,
      showModalRecieved,
      ticketsPDF,
      exportExcel,
      isOpen,

      transportList,
      zoneTransports,
      transport,
      providerList,
      provider,
      expediting,
      apiNote,
      apiShipments,
      apiLoading,
      apiCounts,
      retrying,
      openedShipment,
      prettyJson,
      showApiResults,
      retryShipments,
      code_transport,
      sacs_transport,
      fees_transport,
      // Return missing refs
      TransRow,
      transport_auto,
      code_transport_auto,
      fees_transport_auto,
      sacs_transport_auto,

      livreur,
      livsZone,
      auto_distr,
      ZonesList,
      todayDt,
      firstDt,
      selectedDate,
      showCalendar,
      showCalendarBox,
      recept_zone_filter,
      sent_zone_filter,
    };
  },
};
</script>
<style scoped>
.api-results .api-error {
  max-width: 340px;
  color: var(--ui-danger, #d33);
  font-size: 13px;
  word-break: break-word;
}
.api-detail pre {
  max-height: 260px;
  margin: 4px 0 0;
  padding: 10px;
  overflow: auto;
  border-radius: 6px;
  background: #f4f5f7;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
